import {
    Paper,
    TextField,
    Snackbar,
    Alert,
} from '@mui/material';
import {
    DataGrid,
    GridToolbar,
    useGridApiRef,
} from '@mui/x-data-grid'; // GridColumnVisibilityModel,



import React, { useEffect, useState, useContext } from 'react';
import { GlobalContext } from '../../App'
import AddPlyToLadder from './addPlyToLadder';

import { db } from '../../firebase';


export default function StickyHeadTable(props) {
    const [ladderData, setladderData] = useState([{ id: 'id' }])
    const [isAdmin, setIsAdmin] = useContext(GlobalContext);

    // The resultant DataGrid object needs to be initialized with this
    const apiRef = useGridApiRef();

    const columnsAdmin = [
        // {
        //     field: 'id',
        //     headerName: 'Ranking',
        //     width: 75,
        //     renderCell: (params) => {
        //         const index = apiRef.current.getRowIndexRelativeToVisibleRows(params.row.id) + 1;

        //         return <TextField value={index} />;
        //     },
        // },
        { field: 'name', headerName: 'Name', width: 200 },
        { field: 'uid', headerName: 'Uid', width: 200 },
        {
            field: 'pennantScore', headerName: 'ANU Pennant Score', type: 'number', width: 200,
            editable: true,
            renderCell: (params) => {
                return <TextField value={params.value} />;
            },
        },
        {
            field: 'anuopenScore',
            headerName: 'ANU Open Score',
            type: 'number',
            width: 200,
            editable: true,
            renderCell: (params) => {
                return <TextField value={params.value} />;
            },
        },
        {
            field: 'totalScore',
            headerName: 'Total Score',
            type: 'number',
            description: 'Total score is the sum of ANU Pennant Score and ANU Open Score',
            sortable: true,
            width: 200,
        },
    ];
    const columnsUser = [
        {
            field: 'id',
            headerName: 'Ranking',
            width: 75,
            renderCell: (params) => {
                const index = apiRef.current.getRowIndexRelativeToVisibleRows(params.row.id) + 1;

                return <TextField value={index} />;
            },
        },
        { field: 'name', headerName: 'Name', width: 200 },
        {
            field: 'totalScore',
            headerName: 'Total Score',
            type: 'number',
            description: 'Total score is the sum of ANU Pennant Score and ANU Open Score',
            sortable: true,
            width: 200,
        },
        {
            field: 'pennantScore', headerName: 'ANU Pennant Score', type: 'number', width: 200,
        },
        {
            field: 'anuopenScore',
            headerName: 'ANU Open Score',
            type: 'number',
            width: 200,
        },
    ];

    function fetchLadder() {
        db.collection("ladder").get().then((querySnapshot) => {
            let ladderTable = []
            querySnapshot.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                doc = doc.data()
                ladderTable.push({
                    name: doc.name,
                    uid: doc.uid,
                    pennantScore: doc.pennantScore,
                    anuopenScore: doc.anuopenScore,
                    totalScore: doc.totalScore,
                })

            });

            // sanitization
            // fill in blank numerical values with 0s
            ladderTable.forEach((row) => {
                var modMade = false
                for (var property in row) {
                    if (property === 'pennantScore' || property === 'anuopenScore') {
                        if (row[property] === undefined || row[property] === null) {
                            row[property] = 0
                            modMade = true
                        }
                    }
                    if (property === 'totalScore') {
                        row[property] = parseInt(row['pennantScore']) + parseInt(row['anuopenScore'])
                    }
                }
            })
            ladderTable = ladderTable.filter((row) => row.uid ? row : null)

            setladderData(ladderTable.map((row) => {
                return {
                    ...row,
                    id: row.uid
                }
            }))
        });
    }


    // ## editable table
    const mutateRow = async (newRow) => {
        // this function returns a promise

        // console.log(`mutateRow id:${newRow.id}`, newRow.uid, newRow.name)
        newRow.totalScore = parseInt(newRow.anuopenScore) + parseInt(newRow.pennantScore)
        return new Promise((resolve, reject) => {
            db.collection('ladder').doc(newRow.uid)
                .update(newRow)
                .then(() => {
                    // fetchLadder()
                    setladderData(ladderData.map((row) => {
                        if (row.uid === newRow.uid) {
                            return newRow
                        }
                        else return row
                    }))
                    console.log(`Update success ${newRow.uid} ${newRow.name} `)
                    resolve(`Update success ${newRow.uid} ${newRow.name} `)
                })
                .catch((e) => {
                    console.error(e)
                    console.log(`reject!!!`)
                    reject(e)
                })
        }
        )
    }

    const [snackbar, setSnackbar] = React.useState(null);
    const handleCloseSnackbar = () => setSnackbar(null);

    const processRowUpdate = React.useCallback(
        async (newRow) => {
            // Make the HTTP request to save in the backend
            const response = await mutateRow(newRow);
            setSnackbar({ children: `User ${newRow.name} successfully saved`, severity: 'success' });
            return response;
        },
        [mutateRow],
    );

    const handleProcessRowUpdateError = React.useCallback((error) => {
        // setSnackbar({ children: error.message, severity: 'error' });
        console.error(error)
    }, []);

    useEffect(() => {
        fetchLadder()
    }, [])

    useEffect(() => {
        // updateMapPlyNameId()
        console.log('ladderData: ', ladderData)
    }, [ladderData])

    function AdminPage(props) {

        return (
            <div>
                <div>You are now viewing the Admin Page</div>
                <div>CHANGES ARE NOT REVERTABLE. PLEASE BE CAREFUL WITH MODIFICATIONS!!!</div>
                <Paper className='padding margin'>

                    <div >
                        {/* <div style={{ height: 800, width: '100%' }}></div> </div> */}

                        <AddPlyToLadder fetchLadder={fetchLadder} setSnackbar={setSnackbar} ></AddPlyToLadder>

                        <DataGrid
                            autoHeight
                            rows={ladderData}
                            columns={columnsAdmin}
                            slots={{ toolbar: GridToolbar }}
                            processRowUpdate={processRowUpdate}
                            onProcessRowUpdateError={handleProcessRowUpdateError}
                            checkboxSelection={true}
                            initialState={{
                                sorting: {
                                    sortModel: [{ field: 'totalScore', sort: 'desc' }],
                                },
                            }}
                        />
                    </div>
                </Paper>
            </div>
        )
    }

    function UserPage(props) {

        return (
            <div>
                <div>You are now viewing the User Page</div>
                <Paper className='padding margin'>

                    <div >
                        {/* <div style={{ height: 800, width: '100%' }}></div> </div> */}
                        <DataGrid
                            autoHeight
                            apiRef={apiRef}
                            rows={ladderData}
                            columns={columnsUser}
                            initialState={{
                                sorting: {
                                    sortModel: [{ field: 'totalScore', sort: 'desc' }],
                                },
                            }}
                        />
                    </div>
                </Paper>
            </div>
        )
    }

    return (
        <div>
            <span>Welcome to Ladder</span>

            {isAdmin ? <AdminPage></AdminPage> : <UserPage></UserPage>}
            {!!snackbar && (
                <Snackbar
                    open
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    onClose={handleCloseSnackbar}
                    autoHideDuration={6000}
                >
                    <Alert {...snackbar} onClose={handleCloseSnackbar} />
                </Snackbar>
            )}
        </div>
    );
}


